(()=>{
  if(window.__mingsilkProductSamplingR4)return;
  window.__mingsilkProductSamplingR4=true;
  const apply=(scope=document)=>{
    scope.querySelectorAll('product-info [data-reverie-inquiry-add]').forEach(button=>{
      const add='Save selected fabric to project shortlist';
      const remove='Remove from project shortlist';
      const text=button.querySelector('.reverie-inquiry-button-text');
      const active=button.dataset.reverieInquiryActive==='true';
      if(text){text.dataset.originalText=add;text.textContent=active?remove:add}
      button.dataset.loadingLabel='Saving selected fabric…';
      button.dataset.addedLabel='Saved to your project shortlist. [count] fabric(s) saved.';
      button.dataset.duplicateLabel='This fabric is already in your project shortlist.';
      button.dataset.limitLabel='Your project shortlist can hold up to 100 fabrics. Remove one before adding another.';
      button.dataset.errorLabel='This fabric could not be saved. Please try again.';
      button.dataset.removeLabel=remove;
      button.dataset.removedLabel='This fabric was removed from your project shortlist.';
      button.dataset.addAriaLabel=add;
      button.dataset.removeAriaLabel=remove;
      button.setAttribute('aria-label',active?remove:add);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>apply(),{once:true});else apply();
  document.addEventListener('shopify:section:load',event=>apply(event.target));
})();
